import React from 'react';
import LandingMediaKitMediaLabProduction from '../TNOMediaKitMediaLabProduction/LandingMediaKitMediaLabProduction';
import {
  alterGoldMediaLabWho,
  alterGoldMediaLabWhy,
  alterGoldMediaLabBenefits,
  alterGoldMediaLabValues,
  alterGoldMediaLabAreYouReady,
} from '../TNOMediaKitMediaLabProduction/alterGoldMediaLabContent';

const LandingMediaKitAlterGoldPrograma = (props) => (
  <LandingMediaKitMediaLabProduction
    {...props}
    proposalSlug="alter-gold-programa"
    mediaLabContent={{
      who: alterGoldMediaLabWho,
      why: alterGoldMediaLabWhy,
      benefits: alterGoldMediaLabBenefits,
      values: alterGoldMediaLabValues,
      areYouReady: alterGoldMediaLabAreYouReady,
    }}
  />
);

export default LandingMediaKitAlterGoldPrograma;
